<div *ngIf="_userService.user.role == 'assistant'">
  <h4>
    {{ 'MANAGE_MY_CONSULTANTS' | translate }}
  </h4>
  <hr>
</div>

<div *ngIf="_userService.user.role != 'assistant'">

  <database-resource-menu></database-resource-menu>

  <hr>

  <div class="alert alert-warning alert-dismissible fade show" role="alert"
    *ngIf="_resourceService.alert">
    {{ _resourceService.alert | translate }}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"
      (click)="_resourceService.alert = null">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>


  <div class="d-flex justify-content-end">
    <button class="btn btn-main-color btn-sm  cursor-hand" data-toggle="modal" data-toggle="modal"
      data-target="#consultantModal">
      {{ 'ADD_NEW' | translate }}
    </button>
  </div>



  <div class="col-lg-12">
    <ul class="nav nav-tabs">
      <!--     <li class="nav-item">
      <a href="" data-target="#searchbyname" data-toggle="tab"
        class="nav-link tab-link btn-sm active" (click)="consultant.id = ''">
        {{ 'SEARCH_BY_NAME' | translate}}
      </a>
    </li> -->
      <li class="nav-item">
        <a href="" data-target="#searchbyid" data-toggle="tab"
          class="nav-link tab-link btn-sm active" (click)="consultant.name = ''">
          {{ 'SEARCH_BY_ID' | translate}}
        </a>
      </li>
      <!--     <li class="nav-item">
      <a href="" data-target="#searchbyunit" data-toggle="tab" class="nav-link tab-link btn-sm">
        {{ 'SEARCH_BY_UNIT' | translate}}
      </a>
    </li> -->
    </ul>
    <div class="tab-content py-4">

      <!--Tab searchbyname-->
      <!-- <div class="tab-pane active" id="searchbyname">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>{{ 'NAME' | translate}}</label>
          <div class="input-group mb-3">
            <input class="form-control" type="text" [value]="consultant.personalData.name"
              name="name" [(ngModel)]=consultant.personalData.name>
          </div>
        </div>

      </div>

      <div class="form-group row mt-4">
        <div class="form-group col-md-12">
          <button type="submit" class="btn btn-main-color btn-block" (click)="searchConsultants()">
            {{ 'SEARCH' | translate}}
          </button>
        </div>
      </div>
    </div> -->

      <!--Tab searchbyid-->
      <div class="tab-pane active" id="searchbyid">
        <div class="form-row">

          <div class="form-group col-md-12">
            <label>{{ 'ID' | translate}}</label>
            <div class="input-group mb-3">
              <input class="form-control" type="text" [value]="consultant.id" name="id"
                [(ngModel)]=consultant.id maxlength="10">
            </div>
          </div>
        </div>

        <div class="form-group row mt-4">
          <div class="form-group col-md-12">
            <button type="submit" class="btn btn-main-color btn-block"
              (click)="searchConsultants()">
              {{ 'SEARCH' | translate}}
            </button>
          </div>
        </div>
      </div>

      <!--Tab searchbyunit-->
      <!-- <div class="tab-pane" id="searchbyunit">
      <div class="form-row">

        <div class="form-group col-md-4">
          <label>{{ 'CHOOSE_HOSPITAL' | translate}}</label>
          <div class="input-group mb-3">
            <select name="hospital" class="form-control" [(ngModel)]=hospital
              (ngModelChange)="getDepartments($event)">
              <option *ngFor="let hospital of _databaseResourcesService.allHospitals"
                [ngValue]="hospital">
                {{ hospital.name }}
              </option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary"
                (click)="hospital = null; departments = null" [disabled]="!hospital">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>


        <div class="form-group col-md-4">
          <label>{{ 'CHOOSE_DEPARTMENT' | translate}}</label>
          <div class="input-group mb-3">
            <select name="department" class="form-control" [(ngModel)]=department
              (ngModelChange)="getSubdepartments($event)"
              [disabled]="!hospital || (departments && !departments.length)">
              <option *ngFor="let department of departments" [ngValue]="department">
                {{ department.name }}
              </option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary"
                (click)="department = null; subdepartments = null; consultants = null"
                [disabled]="!department">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>


        <div class="form-group col-md-4">
          <label>{{ 'CHOOSE_SUBDEPARTMENT' | translate}}</label>
          <div class="input-group mb-3">
            <select name="subdepartment" class="form-control" [(ngModel)]=subdepartment
              [disabled]="!department || (subdepartments && !subdepartments.length)">
              <option *ngFor="let subdepartment of subdepartments" [ngValue]="subdepartment">
                {{ subdepartment.name }}
              </option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="subdepartment = null;"
                [disabled]="!subdepartment">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row mt-4">
        <div class="form-group col-md-6">
          <button type="submit" class="btn btn-main-color btn-block"
            (click)="madeUnitToGetConsultants()" [disabled]="hospital && !department">
            {{ 'SEARCH' | translate}}
          </button>
        </div>
      </div>

    </div> -->

      <!-- Fin tab búsqueda por unidad-->


    </div>
  </div>
</div>





<loading-component *ngIf="_databaseResourcesService.loading"></loading-component>


<div class="alert alert-warning margin-top-5" role="alert"
  *ngIf="searchedConsultants && !searchedConsultants.length">
  {{ 'NO_CONSULTANTS' | translate }}
</div>

<div class="card sm-12 margin-top-5 btn-main-color"
  *ngFor="let consultant of searchedConsultants; let last = last" [ngClass]="{'last-child': last}">
  <div class="card-header text-row-background-color-white">
    <div class="row" *ngIf="consultant.personalData">
      <div class="col-10" routerLink="/admin/database-resources/consultants/edit-consultant"
        (click)="_databaseResourcesService.consultant = consultant">
        {{consultant.id}} - {{consultant.personalData.name}} {{consultant.personalData.lastname}}
      </div>
      <div class="col-2 text-right">
        <div ngbDropdown class="d-inline-block">
          <i class="fas fa-pencil-alt cursor-hand" aria-hidden="true"
            routerLink="/admin/database-resources/consultants/edit-consultant"
            (click)="_databaseResourcesService.consultant = consultant"
            [title]="'EDIT' | translate"></i>
          |
          <i class="fas fa-trash-alt cursor-hand" aria-hidden="true"
            (click)="deleteConsultant(consultant)" [title]="'DELETE' | translate"></i>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!consultant.personalData">
      <div class="col-10" routerLink="/admin/database-resources/consultants/edit-consultant"
        (click)="_databaseResourcesService.consultant = consultant">
        ERROR - {{consultant.email}} DOES NOT EXIST AS A USER IN PORTAL
      </div>
    </div>
  </div>
</div>
&nbsp;


<!-- Consultant Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="consultantModal" tabindex="-1" role="dialog"
  aria-labelledby="consultantModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'NEW_CONSULTANT' | translate}} {{_userService.loading}}</div>
        <h5 class="modal-title" id="consultantModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <loading-component *ngIf="_databaseResourcesService.loading || _userService.loading">
      </loading-component>

      <div class="modal-body" *ngIf="!_databaseResourcesService.loading && !_userService.loading">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <form>
          <div class="form-group row  margin-top">
            <label for="id" class="col-sm-3 col-form-label">{{ 'ID' | translate}} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.id" name="id"
                [(ngModel)]=newConsultant.id maxlength="10">
            </div>
          </div>
          <div class="form-group row">
            <label for="name" class="col-sm-3 col-form-label">{{ 'NAME' | translate}} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.name" name="name"
                [(ngModel)]=newConsultant.name>
            </div>
          </div>

          <div class="form-group row">
            <label for="lastname" class="col-sm-3 col-form-label">{{ 'LASTNAME' | translate}}
              *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.lastname"
                name="lastname" [(ngModel)]=newConsultant.lastname>
            </div>
          </div>

          <div class="form-group row  margin-top">
            <label for="id" class="col-sm-3 col-form-label">{{ 'PHONE_NUMBER' | translate}}
              *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.phoneNumber"
                name="phoneNumber" [(ngModel)]=newConsultant.phoneNumber>
            </div>
          </div>

          <div class="form-group row  margin-top">
            <label for="id" class="col-sm-3 col-form-label">{{ 'ADDRESS' | translate}}</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.address" name="address"
                [(ngModel)]=newConsultant.address>
            </div>
          </div>

          <div class="form-group row  margin-top">
            <label for="id" class="col-sm-3 col-form-label">{{ 'FLAT_NUMBER' | translate}}</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.flatNumber"
                name="flatNumber" [(ngModel)]=newConsultant.flatNumber maxlength="10">
            </div>
          </div>

          <div class="form-group row  margin-top">
            <label for="id" class="col-sm-3 col-form-label">{{ 'EMAIL' | translate}} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="newConsultant.email" name="email"
                [(ngModel)]=newConsultant.email>
            </div>
          </div>

          <div class="form-group row  margin-top">
            <label for="portalRole" class="col-sm-3 col-form-label">{{ 'ROLE' | translate}}
              *</label>
            <div class="col-sm-9">
              <select class="form-control" [(ngModel)]="newConsultant.portalRole" name="portalRole"
                placeholder="Select role">
                <option value="consultant">Consultant</option>
                <option value="assistant">Assistant</option>
              </select>
            </div>
          </div>
          <!--           <div class="form-group row">
            <label for="password" class="col-sm-3 col-form-label">{{ 'PASSWORD' | translate}}
              *</label>
            <div class="col-sm-9">
              <input class="form-control" type="password" [value]="newConsultant.password"
                name="password" [(ngModel)]=newConsultant.password>
            </div>
          </div> -->


          <div class="form-group row mt-4">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-main-color btn-block"
                (click)="addConsultant(newConsultant)">
                {{ 'CREATE' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>